/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentV1AgentPatch422ResponseValidationErrorsInner from './AgentV1AgentPatch422ResponseValidationErrorsInner';

/**
 * The AgentV1AgentPatch422Response model module.
 * @module model/AgentV1AgentPatch422Response
 * @version 1.0.0
 */
class AgentV1AgentPatch422Response {
    /**
     * Constructs a new <code>AgentV1AgentPatch422Response</code>.
     * @alias module:model/AgentV1AgentPatch422Response
     */
    constructor() { 
        
        AgentV1AgentPatch422Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1AgentPatch422Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1AgentPatch422Response} obj Optional instance to populate.
     * @return {module:model/AgentV1AgentPatch422Response} The populated <code>AgentV1AgentPatch422Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1AgentPatch422Response();

            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], ['String']);
            }
            if (data.hasOwnProperty('validation_errors')) {
                obj['validation_errors'] = ApiClient.convertToType(data['validation_errors'], [AgentV1AgentPatch422ResponseValidationErrorsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1AgentPatch422Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1AgentPatch422Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['errors'])) {
            throw new Error("Expected the field `errors` to be an array in the JSON data but got " + data['errors']);
        }
        if (data['validation_errors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['validation_errors'])) {
                throw new Error("Expected the field `validation_errors` to be an array in the JSON data but got " + data['validation_errors']);
            }
            // validate the optional field `validation_errors` (array)
            for (const item of data['validation_errors']) {
                AgentV1AgentPatch422ResponseValidationErrorsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<String>} errors
 */
AgentV1AgentPatch422Response.prototype['errors'] = undefined;

/**
 * 表示文言に依存しない入力エラー。旧APIでは省略される。
 * @member {Array.<module:model/AgentV1AgentPatch422ResponseValidationErrorsInner>} validation_errors
 */
AgentV1AgentPatch422Response.prototype['validation_errors'] = undefined;






export default AgentV1AgentPatch422Response;

